/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import * as types from './mutation-types'
// import Vue from 'vue'

export const panelActive = ({ commit }, bstate) => {
  commit(types.PANELACTIVE, bstate)
}

export default {
  panelActive,
}


// WEBPACK FOOTER //
// ./src/store/modules/sinisters/actions.js